import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=5ee4751c"
import script from "./WordCloud.vue?vue&type=script&lang=ts"
export * from "./WordCloud.vue?vue&type=script&lang=ts"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=5ee4751c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports